const Hero = (props) => {

  return (
    <div className="hero">
        <div className="hero-text">
          <h1 className="big">Welcome to <span className="attn">Rummage</span>,</h1> a place to help you declutter, let go of unwanted or unused items, and browse for things you may have not known you needed until now. Turn that trash into cash!
        </div>
    </div>
  )
}

export default Hero 